import { render } from "./Paymaster.vue?vue&type=template&id=26583286&scoped=true&ts=true"
import script from "./Paymaster.vue?vue&type=script&lang=ts"
export * from "./Paymaster.vue?vue&type=script&lang=ts"

import "./Paymaster.vue?vue&type=style&index=0&id=26583286&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26583286"]])

export default __exports__